/** Create/Edit dialog for Activities (content fields + place + cover image). */
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import {
	Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from '@/components/ui/dialog';
import { CoverUpload } from '@/components/media/Cover';
import { TextField, TextArea, SelectField } from './_formkit';

const EMPTY = { title: '', category: '', place_id: '', description: '', cover_media_id: null };

export function ActivityFormDialog({ open, onOpenChange, initial, places = [], canManage, onSubmit, pending }) {
	const [f, setF] = useState(EMPTY);
	const isEdit = !!initial;

	useEffect(() => {
		if (!open) return;
		setF(initial ? {
			title: initial.title || '', category: initial.category || '', place_id: initial.place_id || '',
			description: initial.description || '', cover_media_id: initial.cover_media_id || null,
		} : EMPTY);
	}, [open, initial]);

	const set = (k) => (v) => setF((s) => ({ ...s, [k]: v }));

	const submit = (e) => {
		e.preventDefault();
		onSubmit({
			title: f.title,
			category: f.category || undefined,
			place_id: f.place_id || undefined,
			description: f.description || undefined,
			cover_media_id: f.cover_media_id || undefined,
		});
	};

	const heading = isEdit ? 'Modifica attività' : (canManage ? 'Nuova attività' : 'Richiesta attività');

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="bg-slate-900 text-slate-100 border-slate-800 max-h-[90vh] overflow-y-auto">
				<DialogHeader>
					<DialogTitle>{heading}</DialogTitle>
					<DialogDescription className="text-slate-400">Approvazione e pubblicazione si gestiscono dai pulsanti dedicati.</DialogDescription>
				</DialogHeader>
				<form onSubmit={submit} className="space-y-3">
					<CoverUpload previewUrl={initial?.cover_url} onChange={set('cover_media_id')} />
					<TextField label="Titolo" value={f.title} onChange={set('title')} required data-testid="activity-title-input" />
					<TextField label="Categoria" value={f.category} onChange={set('category')} />
					<SelectField label="Luogo" value={f.place_id} onChange={set('place_id')}
						options={places.map((p) => ({ value: p.id, label: p.name }))} placeholder="Nessun luogo" />
					<TextArea label="Descrizione" value={f.description} onChange={set('description')} rows={3} />
					<DialogFooter>
						<Button type="submit" disabled={pending} data-testid="activity-submit" className="bg-emerald-400 text-slate-950 hover:bg-emerald-300">
							{isEdit ? 'Salva modifiche' : 'Invia'}
						</Button>
					</DialogFooter>
				</form>
			</DialogContent>
		</Dialog>
	);
}
